export enum StepFilterCar {
  stepOne = 'mark',
  stepTwo = 'model',
  stepThree = 'year',
  stepFour = 'modification',
}

export enum TabCarType {
  TyresTab,
  DisksTab,
  AkbTab,
}

export enum AxisType {
  allAxes = '0',
  frontAxles = '1',
  rearAxles = '2',
}

export enum TypeSize {
  factory = '1',
  replacement = '2',
  tuning = '3',
}
